import { Box, Tooltip } from '@chakra-ui/react';
import { BiCalendarEvent } from 'react-icons/bi';
import { MdOutlineTimer } from 'react-icons/md';

import { FollowUp, FollowUpTypeEnum, Maybe } from '../../gql/generated/graphql';

import { formatDateAndTime } from '../../utils/dates';
import { getFollowUpColor } from '../../utils/deals';
import { getFollowUpTypeLabel } from '../../utils/followUps';

type FollowUpBadgeProps = {
  followUp: Maybe<FollowUp>;
  size: number;
};

const FollowUpBadge = ({ followUp, size = 20 }: FollowUpBadgeProps) => {
  if (!followUp) {
    return null;
  }

  const tooltipNotes =
    (followUp.note?.length ?? 0) > 75 ? `${followUp.note?.slice(0, 75)}...` : followUp.note;

  const tooltipLabel = `${formatDateAndTime(followUp.date_utc)} - ${getFollowUpTypeLabel(
    followUp.type,
  )}${tooltipNotes ? ` - ${tooltipNotes}` : ''}`;

  return (
    <Tooltip hasArrow label={tooltipLabel} placement="top" w="220px" borderRadius={5}>
      <Box color={getFollowUpColor(followUp)}>
        {followUp.type === FollowUpTypeEnum.Appointment ? (
          <BiCalendarEvent size={size} />
        ) : (
          <MdOutlineTimer size={size} />
        )}
      </Box>
    </Tooltip>
  );
};

export default FollowUpBadge;
